import { Injectable } from '@angular/core';
import { NeskoAbEigentumListEntry } from 'app/core/amtlichebewertung-api';
import { PersonstammpersonService, ZentralePersonDetailEntryMeta } from 'app/core/personstamm-api';

@Injectable()
export class NeskoabViewmodelService {
  constructor(private personService: PersonstammpersonService) {}

  getViewModel(entries: Array<NeskoAbEigentumListEntry>): Array<NeskoAbEigentumListEntryVm> {
    const res = new Array<NeskoAbEigentumListEntryVm>();
    for (const entry of entries) {
      res.push(new NeskoAbEigentumListEntryVm(entry, this.personService));
    }
    return res;
  }
}

export class NeskoAbEigentumListEntryVm {
  zentralePerson: ZentralePersonDetailEntryMeta;
  mitgliederVm: Array<NeskoAbEigentumListEntryVm>;

  constructor(
    public object: NeskoAbEigentumListEntry,
    private personService: PersonstammpersonService
  ) {
    if (object.zpvNummer) {
      personService.getZentralePerson(object.zpvNummer).subscribe((person) => (this.zentralePerson = person));
    }
    if (object.mitglieder) {
      this.mitgliederVm = new Array<NeskoAbEigentumListEntryVm>();
      for (const person of object.mitglieder) {
        this.mitgliederVm.push(new NeskoAbEigentumListEntryVm(person, personService));
      }
    }
  }
}
